import { UIHeading4, UIText2 } from '@cian/ui-kit';
import * as styles from './ServicePrice.css';
import * as React from 'react';
import { numberToPrettyString } from '@cian/utils';
import { NBSP } from '../../../../../../../../../constants/symbols';

interface IServicePriceProps {
  price: number;
  suffix: string;
}

export const ServicePrice = ({ price, suffix }: IServicePriceProps) => {
  return (
    <div className={styles.root}>
      <UIHeading4>{numberToPrettyString(price)}</UIHeading4>
      {NBSP}
      <div className={styles.dimensions}>
        <UIText2>{suffix}</UIText2>
      </div>
    </div>
  );
};
